import dayjs from "dayjs";

const Constants = {
    Api:{
        commonUrl:(window.location.host.includes('localhost') || window.location.host.includes('formedev')) ? 'https://services2.clarity4d.com/c4dMobileDev/ForMeMobile.asmx/' : 'https://services2.clarity4d.com/c4dMobileProd/ForMeMobile.asmx/'
    },
    dashboardJson : {
        dashboardId : 'HOME',
        period : dayjs().subtract(6, 'month').format('DD/MM/YYYY')
    },
    profileStatusJson : {
        statusPeriod : '6MTH'
    },
    loginContainer : {
        formLabel : {
            usernameLabel : 'User name',
            passwordLabel : 'Password',
            buttonLabel : 'Login',
            versionLabel : 'Version'
        }
    },
    emailJS:{
        serviceName: 'service_4hfz3rm',
        key: 'Ha6CtAyRG7PFMtJOQ',
        templateName: 'template_pwkdsgb'
    },
    helpWindow: {
        name: '_blank',
        height: '600',
        width: '600'
    },
    MenuProps: {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    }
}

export default Constants;

// fireni2206@gpipes.com
// Raw123!@#